import MUIDataTable from 'mui-datatables'
import React, { useEffect } from 'react'
import { Typography, makeStyles, IconButton } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit'
import DeleteIcon from '@material-ui/icons/Delete'

import { Button, Container, FormikDialog } from 'src/modules/ui'
import { useActionRunner } from 'src/modules/notification'

import { useAdmin } from '../hooks'
import {
  AddEnvironmentsModal,
  EditEnvironmentsModal,
} from './EnvironmentsModal'

const useStyles = makeStyles(theme => ({
  addButton: {
    marginLeft: theme.spacing(2),
  },
  columnButton: {
    margin: theme.spacing(0.5),
  },
}))

const Environments = () => {
  const classes = useStyles()

  const {
    fetchPurchasingEnvironments,
    deletePurchasingEnvironments,
    purchasingEnvironments,
  } = useAdmin()
  const [fetchData] = useActionRunner(fetchPurchasingEnvironments)

  useEffect(() => {
    fetchData()
  }, [])

  const purchasingEnvironmentsWrap = Array.isArray(purchasingEnvironments)
    ? { results: [] }
    : purchasingEnvironments

  const envData = purchasingEnvironmentsWrap.results.map(
    ({ address, ...env }) => ({
      ...env,
      address: address.name,
    })
  )

  console.log(envData)

  // datatable columns
  const columns = [
    {
      name: 'name',
      label: 'Name',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'address',
      label: 'Delivery Address',
      options: {
        filter: false,
        sort: true,
      },
    },
    {
      name: 'id',
      label: ' ',
      options: {
        filter: false,
        sort: true,
        customBodyRender: envId => (
          <>
            <EditEnvironmentsModal
              environment={purchasingEnvironments.results.find(
                e => e.id === envId
              )}
              trigger={props => (
                <IconButton
                  {...props}
                  color="primary"
                  size="small"
                  className={classes.columnButton}
                >
                  <EditIcon fontSize="small" />
                </IconButton>
              )}
            />
            <FormikDialog
              successNotification={{
                image: 'peas',
                message: 'Purchasing environment deleted',
              }}
              onSubmit={() => deletePurchasingEnvironments(envId)}
              submitColor="darkRed"
              submitText="Delete Purchasing Environment"
              trigger={props => (
                <IconButton
                  size="small"
                  color="primary"
                  className={classes.columnButton}
                  {...props}
                >
                  <DeleteIcon fontSize="small" />
                </IconButton>
              )}
            >
              <Typography>
                Are you sure you want to delete this purchasing environment?
              </Typography>
            </FormikDialog>
          </>
        ),
      },
    },
  ]
  //  datatable options
  const options = {
    download: false,
    elevation: 0,
    print: false,
    responsive: 'simple',
    rowsPerPage: 20,
    rowsPerPageOptions: [20, 50, 100],
    rowHover: false,
    selectableRows: 'none',
    viewColumns: false,
    customToolbar: props => (
      <AddEnvironmentsModal
        trigger={props => (
          <Button {...props} color="lightGreen" className={classes.addButton}>
            Add
          </Button>
        )}
      />
    ),
  }

  return (
    <Container muiTable>
      <MUIDataTable
        title={'Purchasing Environments'}
        data={envData}
        columns={columns}
        options={options}
      />
    </Container>
  )
}

export default Environments
